<template>
<div class="in-report-manage">
    <component :is="views"></component>
</div>
</template>

<script>
import zbList from '@/views/ZBGL/components/zbList';
export default {
    data() {
        return {
            views: zbList
        }
    },
    methods: {},
    mounted() {}
}
</script>
